import React from 'react';
import { ReportCommentsForm } from '../forms/reports/report-comments-form';

interface ReportsFlowProps {
  onBackToDashboard?: () => void;
}

export const ReportsFlow: React.FC<ReportsFlowProps> = ({ onBackToDashboard }) => (
  <div className="document-flow-container">
    <div className="flow-header">
      <h2>Report Comments</h2>
      <button type="button" className="back-button" onClick={onBackToDashboard}>Back</button>
    </div>
    <ReportCommentsForm />
  </div>
);
